module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/babel-loader/lib/index.js??ruleSet[1].rules[6].use[0]!./index.js"));
	}, "OnlineRegistration");
}